import React, { useState } from "react";
import { CheckCircle2, Copy, MessageSquare, PlayCircle } from "lucide-react";
import { toast } from "sonner";
import { parApi, parErr } from "@/lib/partnerApi";
import { ProspectWelcome } from "@/components/nds/partnerWelcome/ProspectWelcome";
import { inputCls, GoldButton, GhostButton } from "@/components/nds/windows/resident/ui";

const VIA = { in_person: "with you", own_phone: "on their phone" };

/** Play the prospective-resident welcome for this applicant, or text them a link; shows whether they watched it. */
export function WelcomeBar({ q, onWatched }) {
  const [play, setPlay] = useState(false);
  const [link, setLink] = useState("");
  const [busy, setBusy] = useState(false);
  const w = q.welcome_watched;
  const done = () => parApi.post(`/questionnaires/${q.id}/welcome-watched`).then((rec) => { onWatched(rec); toast.success("Recorded: applicant watched the welcome"); }).catch((e) => toast.error(parErr(e))).finally(() => setPlay(false));
  const text = async () => {
    setBusy(true);
    try { const d = await parApi.post(`/questionnaires/${q.id}/welcome-link`); setLink(d.link); toast.success(`Welcome link sent${d.sms_status ? ` · ${d.sms_status}` : ""}`); } catch (e) { toast.error(parErr(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="q-welcome-bar" className="p-3 border border-nex-gold/25 rounded-sm bg-nex-gold/[0.04] space-y-2">
      <div className="flex flex-wrap items-center gap-2">
        <span data-testid="q-welcome-status" className={`flex-1 min-w-[200px] text-sm inline-flex items-center gap-1.5 ${w ? "text-emerald-300" : "text-nex-muted"}`}>
          {w ? <><CheckCircle2 className="h-4 w-4" /> Applicant watched the welcome {VIA[w.via]} · {new Date(w.at).toLocaleString()}</> : "Resident welcome · not watched yet"}</span>
        <GoldButton data-testid="q-welcome-play" onClick={() => setPlay(true)}><PlayCircle className="h-3 w-3" /> Play for applicant</GoldButton>
        <GhostButton data-testid="q-welcome-text" disabled={busy} onClick={text}><MessageSquare className="h-3 w-3" /> {q.welcome_link_sent_at || link ? "Text link again" : "Text link"}</GhostButton>
      </div>
      {link && <div className="flex items-center gap-2"><input readOnly value={link} onFocus={(e) => e.target.select()} data-testid="q-welcome-link" className={`${inputCls} font-mono text-xs`} />
        <button type="button" aria-label="Copy link" data-testid="q-welcome-copy" onClick={() => navigator.clipboard?.writeText(link).then(() => toast.success("Link copied"))} className="p-2 text-nex-muted hover:text-nex-gold"><Copy className="h-4 w-4" /></button></div>}
      {play && <ProspectWelcome onDone={done} onClose={() => setPlay(false)} />}
    </div>
  );
}
